import { get, post } from '../apiClient';
import env from '../../util/env';
import type {
  AcceptAgreementRequest,
  AgreementBaseResponse,
  AgreementDocumentApiResponse,
} from './types';

const VERSION = 'v2';
const BASE_PATH = `api/${VERSION}`;

export const getAgreements = async () =>
  get<AgreementDocumentApiResponse>(
    `${BASE_PATH}/agreement/documents?userType=user_pd`,
    undefined,
    env.SAM_URL,
  );

export const acceptAgreements = async (request: AcceptAgreementRequest) =>
  post<AgreementBaseResponse>(
    `${BASE_PATH}/agreement/signature`,
    JSON.stringify(request),
    undefined,
    env.SAM_URL,
  );
